ceregoCommon.factory('V3SeriesItemsResource', ['$resource', ($resource) ->
  $resource "", {},
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v3_series_items_path(":series_id")
      params:
        series_id: "@series_id"
])
